interface SitetrackerIconProps {
  size?: number;
}

export function SitetrackerIcon({ size = 15 }: SitetrackerIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="sitetracker-icon"
    >
      <path d="M9.60205 0.132812L19.2031 17.8672L9.60205 13.4724V0.132812Z" fill="#22333B" />
      <path d="M9.60211 0.132812L0 17.8672L9.60211 13.4703V0.132812Z" fill="#798488" />
    </svg>
  );
}
